import React from 'react';
import { translate } from 'helpers/intl';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/SignupPages/ContractFoundNotNum/messages';
import {
  AUTH_BY_CONTRACT,
  PERSONAL_INFO,
} from 'containers/SignupPages/constants';
import IsContractFoundResponse from 'containers/SignupPages/IsContractFoundResponse';

export type ContractFoundNotNumType = {
  intl: IntlShape;
  setSignupStep: Function;
};

const ContractFoundNotNum = (props: ContractFoundNotNumType) => (
  <IsContractFoundResponse
    isFound={true}
    title={translate({ ...messages.title }, props)}
    subTitle={translate({ ...messages.subTitle }, props)}
    nextLabel={translate({ ...messages.suivant }, props)}
    previousLabel={translate({ ...messages.precedent }, props)}
    onClickNext={() => {
      props.setSignupStep(AUTH_BY_CONTRACT);
    }}
    onClickPrevious={() => {
      props.setSignupStep(PERSONAL_INFO);
    }}
  />
);

export default injectIntl(ContractFoundNotNum);
